import Logo from "../../components/items/Logo"
import { motion } from "framer-motion";
import AppContext from "../../context/AppContext";
import { useState, useRef, useContext } from "react"

function ResetPassword() {
    const { goHome } = useContext(AppContext)
    const [errors, setErrors] = useState({
        passwordErr: '',
        password2Err: ''
    })
    
    const [form, setForm] = useState({
        password: '',
        password2: '',
        showPassword: false,
        showPassword2: false,
        passwordFocus: false,
        password2Focus: false
    })

    const passwordRef = useRef()
    const password2Ref = useRef()

    const {
        password,
        password2,
        showPassword,
        showPassword2,
        passwordFocus,
        password2Focus
    } = form

    const {
        passwordErr,
        password2Err
    } = errors

    const handleChange = (e) => {
        setForm(values => ({...values, [e.target.name]: e.target.value}))
    }

    const togglePasswordVisibility = (e) => {
        setForm(values => ({...values, showPassword: !showPassword}))
        passwordRef.current.focus();
    }

    const togglePassword2Visibility = (e) => {
        setForm(values => ({...values, showPassword2: !showPassword2}))
        password2Ref.current.focus();
    }

    const addError = (err, value) => {
        setErrors(values => ({...values, [err]: value}))
    }

    const resetErrors = () => {
        for(const error in errors){
          setErrors(values => ({...values, [error]: ''}))
        }
    }

    const onSubmit = (e) => {
        e.preventDefault()
        resetErrors()

        if(password && password2 && (password !== password2)){
            addError('passwordErr', 'Passwords do not match')
            addError('password2Err', 'Passwords do not match')
            return
        }

        if(password.length < 8){
            addError('passwordErr', 'Password must be at least 8 characters long')
        }

        if(!password){
            addError('passwordErr', 'Please enter your new password')
        }

        if(!password2){
            addError('password2Err', 'Please confirm your new password')
        }

        if(password && password2 && (password === password2) && (password.length >= 8)){
            console.log(form)
        }
    }

  return (
    <motion.main 
      className="user-form" 
      id="reset_password"
      initial={{width: 0}}
      animate={{width: '100%'}}
      exit={{x: window.innerWidth, transition: { duration: 0.1 }}}
    >
      <div className='medbolt-logo' onClick={goHome}>
          <Logo/>
      </div>
      <h1>Reset Password</h1>
      <form noValidate onSubmit={onSubmit} className="reset_password">
        <div className="user-input">
            <label style={{color: passwordFocus ? "#486FD8" : "black"}} htmlFor="password">New Password</label>
            <div id="pass">
                <input ref={passwordRef} required autoComplete="false" id="password" type={showPassword ? "text" : "password"} name="password" value={password || ""} onChange={handleChange}
                onFocus={
                    () => {
                        setForm(values => ({...values, passwordFocus: true}))
                    }
                }
                onBlur={
                    () => {
                        setForm(values => ({...values, passwordFocus: false}))
                    }
                }
                />
                {passwordErr && <div className="error">{passwordErr}</div>}
                <span className="eye" title={showPassword ? "hide password" : "show password"} onClick={togglePasswordVisibility}>{!showPassword ? <i className="fa-regular fa-eye"></i> : <i className="fa-regular fa-eye-slash"></i>}</span>
            </div>
        </div>
        <div className="user-input">
            <label style={{color: password2Focus ? "#486FD8" : "black"}} htmlFor="password2">Confirm Password</label>
            <div id="pass">
                <input ref={password2Ref} required autoComplete="false" id="password2" type={showPassword2 ? "text" : "password"} name="password2" value={password2 || ""} onChange={handleChange}
                onFocus={
                    () => {
                        setForm(values => ({...values, password2Focus: true}))
                    }
                }
                onBlur={
                    () => {
                        setForm(values => ({...values, password2Focus: false}))
                    }
                }
                />
                {password2Err && <div className="error">{password2Err}</div>}
                <span className="eye" title={showPassword2 ? "hide password" : "show password"} onClick={togglePassword2Visibility}>{!showPassword2 ? <i className="fa-regular fa-eye"></i> : <i className="fa-regular fa-eye-slash"></i>}</span>
            </div>
        </div>
        <button type="submit" className="trynow">Reset</button>
      </form>
    </motion.main>
  )
}

export default ResetPassword